(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const menuBtn = document.getElementById('menuBtn');
  const drawer = document.getElementById('mobileDrawer');
  const overlay = document.getElementById('drawerOverlay');
  const closeBtn = document.getElementById('drawerClose');

  let lastFocused = null;

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.classList.add('open');
    overlay.classList.add('active');
    drawer.removeAttribute('inert');
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
    drawer.setAttribute('inert', '');
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  menuBtn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  drawer.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
  });

  // Focus trap while the drawer is open
  drawer.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab') return;
    const f = drawer.querySelectorAll('a[href], button:not([disabled])');
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Desktop nav dropdowns — hover-intent with a close delay so the menu stays
  // open long enough to move the cursor down and choose (per Marcela 2026-07-18).
  (function () {
    var CLOSE_DELAY = 380; // ms grace period before a hovered menu closes
    var items = document.querySelectorAll('.header__inline-nav .has-dropdown, .header__inline-nav .has-mega');
    items.forEach(function (item) {
      var timer = null;
      function open() { clearTimeout(timer); item.classList.add('is-open'); }
      function scheduleClose() {
        clearTimeout(timer);
        timer = setTimeout(function () { item.classList.remove('is-open'); }, CLOSE_DELAY);
      }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      // Keyboard: keep it open while focus is inside, close shortly after leaving.
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose();
      });
      // Esc closes immediately.
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { clearTimeout(timer); item.classList.remove('is-open'); }
      });
    });
  })();

  // Cream at top, white on scroll (per Marcela — matches her current site)
  (function () {
    var wrap = document.querySelector('.header-wrapper');
    if (!wrap) return;
    function onScroll() {
      if (window.scrollY > 24) wrap.classList.add('is-scrolled');
      else wrap.classList.remove('is-scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
